import { Button } from 'components/Button'
import { Tag } from 'components/Post/Tag'
import { StrapiImage } from 'components/StapiImage'
import type { ReactNode } from 'react'
import type { StrapiPost } from 'types/strapi/post'

interface PostPageProps {
  post: StrapiPost
  children: ReactNode
  backLink: { href: string; title: string }
}

export function PostPage({ backLink, children, post }: PostPageProps) {
  return (
    <>
      <Button
        href={backLink.href}
        variant="tertiary"
        iconLeft="arrow-back"
        className="mb-10"
      >
        {backLink.title}
      </Button>
      <div className="mb-2 flex w-full flex-col items-center border-b border-inside pb-6 md:pb-10">
        {post.image ? (
          <StrapiImage
            {...post.image}
            priority
            className="mb-6 max-h-[500px] w-full max-w-[570px] rounded-xl md:mb-10 md:h-full"
          />
        ) : null}
        <div className="space-y-4">
          <h1 className="mx-auto max-w-[800px] text-center text-2xl md:text-4xl">
            {post.title}
          </h1>
          <div className="flex flex-col items-center justify-center space-y-2 md:flex-row md:space-x-2 md:space-y-0">
            <div>
              <Tag variant={post.tag} />
            </div>
            <time
              dateTime={post.publishedAt}
              className="font-medium text-dark-gray"
            >
              {post.formattedPublishedDate}
            </time>
            {post.author?.title ? (
              <div className="font-medium text-dark-gray">
                par{' '}
                {post.author?.url ? (
                  <Button
                    href={post.author?.url}
                    variant="tertiary"
                    className="inline text-dark-gray"
                    innerClassName="inline"
                  >
                    {post.author?.title}
                  </Button>
                ) : (
                  post.author?.title
                )}
              </div>
            ) : null}
            {post.timeToRead ? (
              <div className="font-medium text-dark-gray">
                ({post.timeToRead} min{+post.timeToRead > 1 ? 's' : ''})
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-[800px] py-8">
        <div className="mb-6 text-justify text-2xl">
          {post.shortDescription}
        </div>
        {children}
      </div>
    </>
  )
}
